import { Result } from 'antd';
import type React from 'react';

import { FirebaseAuthForm } from '@/components/FirebaseAuthForm';
import { AuthLayout } from './AuthLayout';

export const LoginView: React.FC = () => {
  return (
    <AuthLayout>
      <Result
        status="403"
        title="Authorization"
        style={{ width: 500, margin: 'auto' }}
        subTitle="Please sign in to access this page."
        extra={<FirebaseAuthForm />}
      />
    </AuthLayout>
  );
};
